module.exports = __webpack_public_path__ + "img/xrbp-the-ultimate-xrp-ruby-interface.01294f43.png";